import React, { useState } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useApprovalThemes } from "pages/approvals/approval-queries";

const CollabThemeDropdown = ({
  onChange = null,
  themeId = null,
  className = "",
  size = "",
}) => {
  const [selected, setSelected] = useState(themeId);
  const { data: themes = [] } = useApprovalThemes();

  const onStatusChange = (themeId) => {
    setSelected(themeId);
    onChange(themeId);
  };

  const options = themes.map(({ _id, name }) => ({ value: _id, label: name }));

  return (
    <Select value={selected || undefined} onValueChange={onStatusChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="Select theme…" />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CollabThemeDropdown;
